module.exports = __webpack_public_path__ + "static/media/outline-icons.cd6c777f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/outline-icons.woff2
// module id = 4408
// module chunks = 0